<template>
  <fieldset :class="$style.group">
    <legend class="sr-only">
      {{ label ?? $t('positions:list.filesLegend') }}
    </legend>
    <ul :class="$style.list">
      <li v-if="!disableNone">
        <FileListItem
          :file="
            {
              id: 'none',
              name: $t('positions:list.doNotReplace'),
            } as CadFile
          "
          :groupName="groupName"
          :isActive="activeId === 'none'"
          @selected="$emit('selected', $event)"
        />
      </li>
      <li v-for="file in files" :key="file.id" :data-id="file.id">
        <FileListItem
          :file="file"
          :groupName="groupName"
          :isActive="file.id === activeId"
          @selected="$emit('selected', $event)"
        />
      </li>
    </ul>
  </fieldset>
</template>
<script setup lang="ts">
import { useId } from 'vue';
import FileListItem from './FileListItem.vue';
import type { CadFile } from '@cutr/constants/order';

defineEmits<{ (e: 'selected', file: CadFile): void }>();
defineProps<{
  files: CadFile[];
  activeId?: string;
  label?: string;
  disableNone?: boolean;
}>();

// Shared radio `name` so all items form one keyboard-navigable group.
const groupName = useId();
</script>
<style module>
.group {
  border: 0;
  margin: 0;
  padding: 0;
  min-inline-size: 0;
}

.list > li + li {
  padding-block-start: 0.5rem;
}
</style>
